/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoAssetsModelsAlphabetAssetListItem,
    AssetsMelcoAssetsModelsAlphabetAssetListItemFromJSON,
    AssetsMelcoAssetsModelsAlphabetAssetListItemFromJSONTyped,
    AssetsMelcoAssetsModelsAlphabetAssetListItemToJSON,
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem
 */
export interface AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem {
    /**
     * 
     * @type {Array<AssetsMelcoAssetsModelsAlphabetAssetListItem>}
     * @memberof AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem
     */
    list: Array<AssetsMelcoAssetsModelsAlphabetAssetListItem>;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem
     */
    total: number;
}

export function AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItemFromJSON(json: any): AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem {
    return AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItemFromJSONTyped(json, false);
}

export function AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(AssetsMelcoAssetsModelsAlphabetAssetListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItemToJSON(value?: AssetsMelcoModelsGenericList1MelcoAssetsModelsAlphabetAssetListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(AssetsMelcoAssetsModelsAlphabetAssetListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


